import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.586 4.929a6 6 0 1 1 8.485 8.485l-1.768 1.769-1.06-1.061 1.768-1.768a4.5 4.5 0 1 0-6.364-6.364L9.878 7.758l-1.06-1.06zm3.535 11.314 1.06 1.06-1.766 1.768a6 6 0 1 1-8.486-8.485l1.767-1.767 1.061 1.06-1.767 1.768a4.5 4.5 0 0 0 6.364 6.364zm.53-5.834a.75.75 0 0 0-1.06-1.06L9.348 13.59a.75.75 0 0 0 1.061 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }